<template>
  <div class="container">
    <v-card>
      <v-card-title v-if="cargando" class="grey lighten-4 change-font" primary-title>
        <div class="spinner-grow"></div>Cargando tareas &#8230;
      </v-card-title>
      <v-card-title v-else class="grey lighten-4 change-font" primary-title>Seguimiento - {{nombre}}</v-card-title>
      <v-card-text>
        <br />
        <v-text-field
          v-model="buscarbandeja"
          append-icon="search"
          label="Buscar"
          single-line
          hide-details
          @keyup="filtrar"
        ></v-text-field>
        <v-spacer></v-spacer>
        <v-data-table
          :headers="headerFields"
          :items="tareasbuscar"
          class="elevation-2"
          :no-data-text="gnodata"
          dense
          :items-per-page="10"

        >
          <template v-slot:item.fechamodificacion="{ item }">{{formato(item)}}</template>
          <template v-slot:item.action="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <div>
                  <v-icon small class="mr-2" @click="editItem(item)" v-on="on">{{icono(item)}}</v-icon>
                </div>
              </template>
              <span>{{texto(item)}}</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
export default {
  name: "bandejaseguimiento",
  props: {
    proceso: Number,
    nombre: String
  },
  data() {
    return {    
      tareas: [],
      tareasbuscar: [],
      tareassinfiltro: [],
      cargando: false,
      buscarbandeja: "",
      headerFields: [
      
    
      ],
      //Parametros de paginación

      timewait: 3,
      filtroIndicadores: [],
      filtroAvances: [],
      filtroHitos: []
    };
  },
  methods: {
    usuario() {
      return JSON.parse(unescape(localStorage.usuario));
    },
    editItem(item) {
      if (this.revisarbloqueo(item) === false) {
        let auten = this.usuario().token.replace("Bearer ", "");
        this.$aes.setKey(auten);
        let cifra = this.$aes.encrypt(item.idelemento.toString());
        let temporal =
          Math.random()
            .toString(36)
            .substring(2, 6) +
          cifra +
          Math.random()
            .toString(36)
            .substring(2, 6);
        let encrypted = this.$aes.encrypt(temporal);
        encrypted = encrypted.replace(/\//g, "AbcYq");
        encrypted = encrypted.replace(/\+/g, "qYcbA");
        let ruta = item.ruta.replace("{0}", encrypted);
        console.log(ruta);
        this.$router.push(ruta);
      }
    },
    color(item) {
      if (item.idusuarioresponsable === null) {
        return "orange";
      } else {
        return "green";
      }
    },
    revisarbloqueo(item) {
      let bloqueado = [];
      let vfiltro = localStorage.IndicadorFiltrado;
      let Afiltro = localStorage.AvanceFiltrado;
      let Hfiltro = localStorage.HitoFiltrado;
      let encontrado = false;
      switch (this.proceso) {
        case 1:
          if (vfiltro !== undefined) {
            bloqueado = JSON.parse(unescape(vfiltro));
            encontrado =
              bloqueado.filter(p => p.indicador === item.idelemento).length > 0;
          }
          break;
        case 2:
          if (Afiltro !== undefined) {
            bloqueado = JSON.parse(unescape(Afiltro));
            encontrado =
              bloqueado.filter(p => p.indicador === item.idelemento).length > 0;
          }
          break;
        case 3:
          if (Hfiltro !== undefined) {
            bloqueado = JSON.parse(unescape(Hfiltro));
            encontrado =
              bloqueado.filter(p => p.idhito === item.idelemento).length > 0;
          }
          break;
      }
      return encontrado;
    },
    texto(item) {
      return this.revisarbloqueo(item) ? "Tarea en proceso" : "Tarea gestionada";
    },
    icono(item) {
      return this.revisarbloqueo(item) ? "schedule" : "mdi-eye";
    },
    formato(value) {
      if (value) {
        return moment(String(value.fechamodificacion)).format("DD/MM/YYYY");
      }
    },
    cargar() {
      this.cargando = false;
      this.tareas = this.gtareasgestionadas.filter(
        p => p.idflujoNavigation.idproceso === this.proceso
      );
      this.tareasbuscar = this.tareas;
    },
    filtrar() {
      if (this.buscarbandeja === "") {
        this.tareasbuscar = this.tareas;
      } else {
        this.tareasbuscar = this.tareas.filter(
          p =>
            p.idflujoNavigation.codigo
              .toUpperCase()
              .indexOf(this.buscarbandeja.toUpperCase()) !== -1 ||
            p.idflujoNavigation.entidad
              .toUpperCase()
              .indexOf(this.buscarbandeja.toUpperCase()) !== -1 ||
            p.idflujoNavigation.nombre
              .toUpperCase()
              .indexOf(this.buscarbandeja.toUpperCase()) !== -1 ||
            p.idflujoNavigation.nombrefiltro
              .toUpperCase()
              .indexOf(this.buscarbandeja.toUpperCase()) !== -1
        );
      }
    }
  },
  created() {  
      let objproceso = this.gprocesos.filter(
        p => p.idproceso === this.proceso
      )[0];
    this.headerFields=[];
    this.headerFields.push({          value: "titulo",          text: "Nombre",          sortable: true,          width: "20%"        });
    if (objproceso.verinstrumento === true) {
      this.headerFields.push({
        value: "idflujoNavigation.instrumento",
        text: "Instrumento de planeación",
        sortable: false,
        width: "10%",
      });
    }
    this.headerFields.push({          value: "idflujoNavigation.entidad",          text: "Entidad",          sortable: true,          width: "25%"        });
    this.headerFields.push({          value: "idflujoNavigation.estado",          text: "Estado",          sortable: true,          width: "150px"        });
    this.headerFields.push({          value: "fechamodificacion",          text: "Fecha última gestión",          sortable: true,          width: "100px"        });
     if (objproceso.verfechacorte === true) {
        this.headerFields.push({
          value: "idflujoNavigation.fechacorte",
          text: objproceso.etiquetafechacorte,
          sortable: true,
          width: "100px"
        });
      }  
    this.headerFields.push( {          text: "Acción",          value: "action",          sortable: false,          width: "100px",          align: "center"        });
    
  },
  computed: {
    ...mapGetters(["gtareasgestionadas", "gconfiguraciones", "gprocesos"]),
    ...mapGetters("mensaje", ["ginformation", "gnodata"])
  },
  mounted() {    
    this.cargar();
  },
  watch: {
    gtareasgestionadas: function() {
      this.cargando = false;
      this.tareas = this.gtareasgestionadas.filter(
        p => p.idflujoNavigation.idproceso === this.proceso
      );
      this.tareasbuscar = this.tareas;
    }
  }
};
</script>
